import { appConfig } from '@common/config';
import { type AxiosError } from 'axios';
import { type TFunction } from 'i18next';
import toast, { type Toast } from 'react-hot-toast';
import { Trans } from 'react-i18next';

export interface IError {
    result: {
        error: string;
        message: string;
    };
}

export const toastOption: Partial<Pick<Toast, 'className' | 'duration' | 'position'>> = {
    duration: 3000,
    className: 'gameinfo-toast',
    position: 'bottom-center',
};

const massageMap: Record<string, string> = {
    default: 'common.dataerror',
    duplicated: 'noti.toast2',
    exceeded: 'noti.toast3',
    game_character: 'noti.choosecharacters',
};

export const useErrorToastMessage = (t?: TFunction<'translation', undefined>, who?: string) => {
    const handleError = (error: Error | null | undefined) => {
        if (!error) return;

        const err = error as AxiosError<IError>;
        const httpStatusText = err.response?.statusText;
        const serviceCode = err.response?.data?.result?.error;

        if (serviceCode) {
            if (
                httpStatusText?.toLocaleLowerCase() === 'unauthorized' ||
                serviceCode.toLocaleLowerCase() === 'unauthorized' ||
                serviceCode.toLocaleLowerCase() === 'unauthenticated'
            ) {
                window.GNBLogin?.();
                return;
            }

            if (serviceCode.toLocaleLowerCase() === 'exceeded' && appConfig.service === 'bnsneo') {
                openToast(t?.('common.exceednumfavsbtn'));
            } else {
                const msg = t?.(massageMap[serviceCode.toLocaleLowerCase()] || massageMap.default);
                openToast(msg);
            }
        }
    };
    return { handleError };
};

const openToast = (message?: string) => {
    if (!message) return;
    toast.dismiss();
    toast(
        (t) => (
            <div className="toast-wrapper">
                <span className="toast-title">
                    <Trans>{message}</Trans>
                </span>
            </div>
        ),
        toastOption
    );
};
